var _mask, _g, _mask2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 46,
    viewBox: "0 0 64 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 46
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.9048 0H6.09524C2.72893 0 0 2.72893 0 6.09524V39.619C0 42.9854 2.72893 45.7143 6.09524 45.7143H57.9048C61.2711 45.7143 64 42.9854 64 39.619V6.09524C64 2.72893 61.2711 0 57.9048 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.9048 0H6.09524C2.72893 0 0 2.72893 0 6.09524V39.619C0 42.9854 2.72893 45.7143 6.09524 45.7143H57.9048C61.2711 45.7143 64 42.9854 64 39.619V6.09524C64 2.72893 61.2711 0 57.9048 0Z",
    fill: "#F65260"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.429 27.4286H19.0656C18.6351 27.4286 18.2861 27.0813 18.2861 26.6491V19.0652C18.2861 18.6347 18.6334 18.2857 19.0656 18.2857H27.429V9.92237C27.429 9.49185 27.7762 9.14285 28.2085 9.14285H35.7923C36.2228 9.14285 36.5718 9.4901 36.5718 9.92237V18.2857H44.9352C45.3657 18.2857 45.7147 18.633 45.7147 19.0652V26.6491C45.7147 27.0796 45.3675 27.4286 44.9352 27.4286H36.5718V35.7919C36.5718 36.2224 36.2246 36.5714 35.7923 36.5714H28.2085C27.778 36.5714 27.429 36.2242 27.429 35.7919V27.4286Z",
    fill: "white"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 46
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.9048 0H6.09524C2.72893 0 0 2.72893 0 6.09524V39.619C0 42.9854 2.72893 45.7143 6.09524 45.7143H57.9048C61.2711 45.7143 64 42.9854 64 39.619V6.09524C64 2.72893 61.2711 0 57.9048 0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.1427 0.761902H6.85696C3.49065 0.761902 0.761719 3.49083 0.761719 6.85714V38.8571C0.761719 42.2234 3.49065 44.9524 6.85696 44.9524H57.1427C60.509 44.9524 63.2379 42.2234 63.2379 38.8571V6.85714C63.2379 3.49083 60.509 0.761902 57.1427 0.761902Z",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCh);
export default __webpack_public_path__ + "static/media/CH.23808532.svg";
export { ForwardRef as ReactComponent };